module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "header": true,
      "customClass": 'heightAuto',
      "footer": true
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('div', {
    staticClass: "py-3",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "fs-larger"
  }, [_vm._v("Rebook reservation to "), _c('span', {
    staticClass: "fs-larger",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.startHour(_vm.event)) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-4 ml-3",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "my-1"
  }, [_c('span', {
    staticClass: "fs-medium bold mb-1 text-center"
  }, [_vm._v("Prices might be different:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 border-bottom mb-3"
  }, [_c('div', {
    staticClass: "d-flex py-4 justify-content-between"
  }, [_c('div', {
    staticClass: "col-sm-6 text-center"
  }, [_c('label', {
    staticClass: "pb-2 fs-normal"
  }, [_vm._v("Current Reservation")]), _vm._v(" "), _vm._l((_vm.currentPrice), function(current) {
    return _c('ul', [(!current.hide) ? _c('li', [_vm._v(_vm._s(current.quantity) + "x  " + _vm._s(current.audienceTypeDescription) + "   \n\t\t\t\t\t\t\t\t" + _vm._s(current.audienceTypeLabel) + "\n\t\t\t\t\t\t\t\t"), (!_vm.getBookingComparisonRebook.hideCategoryPrices) ? _c('span', [_vm._v(": " + _vm._s(current.grossprice) + "€")]) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" Total: " + _vm._s(_vm.getBookingComparisonRebook.bookingCurrentPrice) + "€ ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex py-4 justify-content-between"
  }, [_c('div', {
    staticClass: "col-sm-6 text-center"
  }, [_c('label', {
    staticClass: "pb-2 fs-normal"
  }, [_vm._v("New Reservation - Keep")]), _vm._v(" "), _vm._l((_vm.priceNewKeep), function(current) {
    return _c('ul', [(!current.hide) ? _c('li', [_vm._v(_vm._s(current.quantity) + "x  " + _vm._s(current.audienceTypeDescription) + "   \n\t\t\t\t\t\t\t\t" + _vm._s(current.audienceTypeLabel) + "\n\t\t\t\t\t\t\t\t"), (!_vm.getBookingComparisonRebook.hideCategoryPrices) ? _c('span', [_vm._v(": " + _vm._s(current.grossprice) + "€")]) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" Total: " + _vm._s(_vm.getBookingComparisonRebook.bookingCurrentPrice) + "€ ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-center"
  }, [_c('label', {
    staticClass: "pb-2 fs-normal"
  }, [_vm._v("New Reservation - Change")]), _vm._v(" "), _vm._l((_vm.priceNewChange), function(newprice) {
    return _c('ul', [(!newprice.hide) ? _c('li', [_vm._v(_vm._s(newprice.quantity) + "x  " + _vm._s(newprice.audienceTypeDescription) + "  \n\t\t\t\t\t\t\t\t" + _vm._s(newprice.audienceTypeLabel) + "\n\t\t\t\t\t\t\t\t"), (!_vm.getBookingComparisonRebook.hideCategoryPrices) ? _c('span', [_vm._v(": " + _vm._s(newprice.grossprice) + "€")]) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" Total: " + _vm._s(_vm.getBookingComparisonRebook.bookingNewPrice) + "€ ")])], 2)])]), _vm._v(" "), (!_vm.isMinLimitsSatisfied) ? _c('AlertMessage', {
    attrs: {
      "message": _vm.minLimitsMessage,
      "icon": "ico-alert",
      "bold": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isMaxLimitsSatisfied) ? _c('AlertMessage', {
    attrs: {
      "message": _vm.maxLimitsMessage,
      "icon": "ico-alert",
      "bold": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasMinPaxPerEvent) ? _c('AlertMessage', {
    attrs: {
      "message": _vm.minPaxPerEventMessage,
      "icon": "ico-message",
      "bold": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('span', {
    staticClass: "fs-normal text-center"
  }, [_vm._v("Do you want to  "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" Keep ")]), _vm._v(" or "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" Change ")]), _vm._v(" the price of the reservation? ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": _vm.getIsRescheduling || _vm.isRescheduling
    },
    on: {
      "click": _vm.keepPrices
    }
  }, [_vm._v("Keep")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": _vm.getIsRescheduling || _vm.isRescheduling
    },
    on: {
      "click": _vm.changePrices
    }
  }, [_vm._v("Change")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-664be1be", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-664be1be"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/CompareEventsRebook.vue
// module id = 1390
// module chunks = 0